import {
    SOCIAL_SERVICE_CONTRACTS_DEFAULT,
    SOCIAL_SERVICE_CONTRACTS_KEY,
    SocialServiceSettingsContractsType,
} from '@libs/types/src/services/types/social-service-settings-contracts.type';
import { ServiceSettingsObject } from '@libs/types/src/services/object-type/service/service-settings.object';

export function getContractSettings(
    settings: ServiceSettingsObject[],
    key: string = SOCIAL_SERVICE_CONTRACTS_KEY,
): SocialServiceSettingsContractsType {
    return JSON.parse(
        settings.find((it) => it.key === key)?.data ||
        JSON.stringify(SOCIAL_SERVICE_CONTRACTS_DEFAULT),
    );
}
